import type { ContainerDefinition } from '../../model/types';

export const tableDefinition: ContainerDefinition = {
  kind: 'container',
  type: 'TABLE',
};
